<template>
  <div :class="classParent">
    <label :for="forLabel" :class="labelClass">{{ label }}</label>
    <select
      :class="selectClass"
      :name="selectName"
      :id="selectId"
      v-model="model"
    >
      <option :value="valueDefault">{{ labelDefault }}</option>
      <option v-for="item in items" :value="item.value">{{
        item.label
      }}</option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    classParent: String,
    labelClass: String,
    forLabel: String,
    label: String,
    selectClass: String,
    selectName: String,
    selectId: String,
    value: String,
    valueDefault: String,
    labelDefault: String,
    items: Array,
  },
};
</script>
